module.exports = __webpack_public_path__ + "img/warehouse.2f42824.jpg";